import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { logout } from './userActions';
import { clearUsersList } from '../components/AdminUserList/adminActions';

type DispatchProps = {
  logout: typeof logout;
  clearUsersList: typeof clearUsersList;
};

const mapDispatchToProps = {
  logout,
  clearUsersList,
};

type Props = DispatchProps;

function Logout({ logout, clearUsersList }: Props): JSX.Element {
  useEffect(() => {
    logout('');
    clearUsersList();
  }, [logout, clearUsersList]);

  return <Redirect to="/login" />;
}

export default connect(undefined, mapDispatchToProps)(Logout);
